export const COURSES_SEARCH_HISTORY_KEY = 'courses-search-history'
